import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

import { MembershipsFetchParamsSchemas } from 'schemas/membershipsSchemas'
import { MembershipsFetchParamsTypes } from 'types/memberships'

export const useMemberMembershipsFilterForm = ({
  defaultValues,
}: {
  defaultValues: MembershipsFetchParamsTypes
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<MembershipsFetchParamsTypes>({
    resolver: zodResolver(MembershipsFetchParamsSchemas),
    defaultValues,
  })

  return {
    handleSubmit,
    control,
    errors,
    setValue,
    reset,
    watch,
  }
}
